import { isDefined } from "@grandvisionhq/utils";
import { getVariantItemImageUrl } from "./get-product-image-url.js";
const createFlatVariantList = (variants, flatFacetConfig) => {
  const drawerVariants = variants.map((variant) => {
    const attributes = flatFacetConfig.map((facetKey) => {
      const value = variant.facets[facetKey];
      if (!value) {
        return void 0;
      }
      return { key: facetKey, value };
    }).filter(isDefined);
    const facetTerm = attributes.map((item) => item.value).join(" / ");
    return {
      sku: variant.sku,
      attributes,
      facetTerm,
      name: variant.displayName,
      slug: variant.slug,
      imageUrl: getVariantItemImageUrl(variant.media)
    };
  });
  return drawerVariants;
};
export {
  createFlatVariantList
};
//# sourceMappingURL=create-flat-variant-list.js.map
